function getTab(button) {
    const tabId = button.getAttribute('data-for-offscreen-tab');
    let tab;

    if (tabId) {
        tab = document.querySelector(`[data-offscreen-tab-id=${tabId}]`);
    }

    return tab;
}

function closeTab(button) {
    const tab = getTab(button);

    if (tab) {
        tab.classList.remove('servicingOffscreenTab--open');
    }
}

function openTab(button) {
    const tab = getTab(button);

    if (tab) {
        tab.classList.add('servicingOffscreenTab--open');
    }
}

function init() {
    const openButtons = document.querySelectorAll('.js_openOffscreenTab');
    const closeButtons = document.querySelectorAll('.js_closeOffscreenTab');
    
    openButtons.forEach(openButton => openButton.addEventListener('click', e => openTab(openButton)));
    closeButtons.forEach(closeButton => closeButton.addEventListener('click', e => closeTab(closeButton)));
}

$(document).ready(init);
